import { Outlet } from "react-router-dom";

const SiteAdminPageLayout = () => {
    return (
        <><Outlet /></>
    );
};

export default SiteAdminPageLayout;
